class VwHbsorderhastaDTO {
    id: number = null;
    servisadi?: string = "";
    servisId?: number = null;
    kimlikId?: number = null;
    adsoyad?: string = "";
    muracaatId?: number = null;
    onayli?: string = "H";
    ayaktanId?: number = null;
    hastaservisId?: number = null;
    orderId?: number = null;
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    depoTanimId?: number = null;
    depoDonemId?: number = null;
    orderTarihi?: string = null;
    orderIlacId?: number = null;
    orderIlacIptal?: string = "";
    planTarih?: string = null;
    islemdurum?: number = null;
    acil?: string = "";
    onaydrAd?: string = "";
}
export default VwHbsorderhastaDTO;